module.exports = __webpack_public_path__ + "img/MirrorCut1.246ed5e2.png";